import React from 'react';
import { Platform } from 'react-native';
import { general } from '~/assets/imgs';
import Button from '~/components/Button';
import { Confetti } from '~/components/Lottie';
import AuthLayout from '~/screens/Auth/layout/AuthLayout';
import { LanguageProps } from '~/screens/Auth/layout/AuthLayout/types';
import { StackScreenLayout } from '~/screens/style';
import { t } from '~/utils/i18n';
import {
  ScrollView,
  Header,
  Content,
  Title,
  Descp,
  Footer,
  HeartImage,
} from './style';

type SignUpSuccessLayoutProps = {
  name: string;
  lottieEnabled?: boolean;
  onJoinNow: () => void;
  onJoinLater: () => void;
  onJoinLaterWeb: () => void;
  onLoginWeb: () => void;
  onLogout: () => void;
} & LanguageProps;

export default function SignUpSuccess({
  name,
  lottieEnabled = true,
  selectedLocale,
  onJoinNow,
  onJoinLater,
  onJoinLaterWeb,
  onLoginWeb,
  onLogout,
  onSelectedLocale,
}: SignUpSuccessLayoutProps): JSX.Element {
  const isWeb = Platform.OS === 'web';

  const languageProps = {
    selectedLocale,
    onSelectedLocale,
  };

  if (isWeb) {
    return (
      <AuthLayout
        languageProps={languageProps}
        onCustomLogoPress={onJoinLaterWeb}
      >
        <>
          <Content>
            <Title>{t('signUpSuccess.title', { name })}</Title>
            <Descp>{t('signUpSuccess.descp')}</Descp>
          </Content>
          <Footer>
            <Button
              testID={'buttonJoinLater'}
              type={'primary-brand-02'}
              text={t('signUpSuccess.logIn')}
              flex
              onPress={() => onLoginWeb && onLoginWeb()}
            />
          </Footer>
        </>
      </AuthLayout>
    );
  }

  return (
    <StackScreenLayout>
      <Confetti enabled={lottieEnabled} />
      <ScrollView>
        <Header>
          <Button
            testID={'buttonLogout'}
            type={'secondary-base'}
            size={'sm'}
            text={t('logout')}
            onPress={() => onLogout && onLogout()}
          />
        </Header>
        <Content>
          <HeartImage source={general.double_hearts} />
          <Title>{t('signUpSuccess.title', { name })}</Title>
          <Descp>{t('signUpSuccess.descp')}</Descp>
        </Content>
        <Footer>
          <Button
            testID={'buttonJoinNow'}
            text={t('signUpSuccess.buttonNow')}
            type={'primary-brand-02'}
            size={'2xl'}
            flex
            flexScreenContainer="stack"
            onPress={() => onJoinNow && onJoinNow()}
          />
          <Button
            testID={'buttonJoinLater'}
            text={t('signUpSuccess.buttonLater')}
            type={'secondary-contrast'}
            size={'2xl'}
            flex
            flexScreenContainer="stack"
            onPress={() => onJoinLater && onJoinLater()}
          />
        </Footer>
      </ScrollView>
    </StackScreenLayout>
  );
}
